(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If AMD is supported and the global object (window) in case any JS module is expecting
    // the SectionLazyLoad to exists on the window object.
    define([], () => {
      global.SectionLazyLoad = factory(global);
    });
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this SectionLazyLoad Module.
    global.SectionLazyLoad = factory(global);
    module.exports = global.SectionLazyLoad;
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    global.SectionLazyLoad = factory(global);
  }
}(typeof window !== 'undefined' ? window : {}, (root) => {
  'use strict';

  // Lazy Loading
  function lazyLoadSection(entry) {
    if (entry.getAttribute('data-url')) {
      const url = root.location.protocol + '//' + root.location.hostname + entry.getAttribute('data-url');

      fetch(url).then((response) => {
        response.text().then((data) => {
          // Now the dispatched event contains the raw data that the url returns
          const event = new CustomEvent('sectionLazyLoaded', {
            detail: {
              data,
            }
          });

          // Add the data-prevent-lazy-load-section-default-behavior="true" attribute to prevent the script.
          // from appending the data to the DOM this should only be used if you don't need the response.
          // added to the target element.
          if (!entry.dataset.preventLazyLoadSectionDefaultBehavior) {
            const responseFragment = document.createRange().createContextualFragment(data);
            entry.appendChild(responseFragment);
          }

          entry.dispatchEvent(event);
        });
      });
    }
  }

  /**
   * Callback function used with the intersection observer.
   * @param {*} entries
   * @param {*} observer
   */
  function callback(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        lazyLoadSection(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }

  const options = {
    root: null,
    rootMargin: '100px 0px'
  };

  const rootMarginObserver = new IntersectionObserver(callback, options);

  /**
   * Function used to get all the lazyloaded sections on initial load
   */
  function initLazyLoad() {
    const lazyLoadSections = document.querySelectorAll("[data-component='lazyLoad']");

    // lazy load the sections
    for (let i = 0; i < lazyLoadSections.length; i += 1) {
      rootMarginObserver.observe(lazyLoadSections[i]);
    }
  }

  /**
   * Used to observe a dynamically created element that doesn't exist
   * on initial load (or re-observe an already unobserved element)
   * @param {Element} target the element that will be observed
   */
  function observe(target) {
    rootMarginObserver.observe(target);
  }

  initLazyLoad();

  return {
    observe
  };
}));
